module.exports = __webpack_public_path__ + "img/complete_bg.e558ca2a.png";